import { render } from "./TeamList.vue?vue&type=template&id=03b2e9e4&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"

import "./TeamList.vue?vue&type=style&index=0&id=03b2e9e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b2e9e4"]])

export default __exports__